import React from 'react';
const reviews = [{
  name: 'Carla V.',
  text: '"Pensaba que lo motivaba, pero en realidad lo presionaba. Cambié la forma de hablarle después de los partidos y hoy lo veo más seguro y disfrutando otra vez. Fue un antes y un después."'
}, {
  name: 'Diego G.',
  text: '"Siempre fui exigente y no sabía cómo manejar cuando jugaba mal. Apliqué lo que explica el método y en pocas semanas su actitud en la cancha cambió totalmente."'
}, {
  name: 'Katy C.',
  text: '"Mi hijo estaba perdiendo confianza y ya no quería entrenar. Con el protocolo de presión entendí qué hacer. Hoy volvió a jugar con ganas y se anima mucho más."'
}, {
  name: 'Julián H.',
  text: '"No soy psicólogo y pensé que sería complicado. Es claro, práctico y directo. Me dio herramientas concretas para no improvisar más cuando hay presión."'
}];
export function ReviewsSection() {
  return <section className="w-full text-center" style={{
    padding: '50px 16px',
    background: '#f5f5f5'
  }} data-id="element-149">
      {/* Title */}
      <h2 style={{
      fontSize: '22px',
      fontWeight: 800,
      color: '#111',
      marginBottom: '8px'
    }} data-id="element-150">
        MÁS DE 3.150 PAPÁS Y MAMÁS SATISFECHOS
      </h2>

      {/* Stars */}
      <div style={{
      color: '#22c55e',
      fontSize: '18px',
      letterSpacing: '3px'
    }} data-id="element-151">
        ★★★★★
      </div>

      {/* Green line */}
      <div style={{
      width: '60px',
      height: '3px',
      background: '#22c55e',
      margin: '12px auto 30px auto',
      borderRadius: '2px'
    }} data-id="element-152" />

      {/* Reviews Grid */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '14px',
      maxWidth: '600px',
      margin: '0 auto'
    }} data-id="element-153">
        {reviews.map((review, index) => <div key={index} style={{
        background: '#ffffff',
        padding: '16px',
        borderRadius: '14px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
        textAlign: 'left'
      }} data-id="element-154">
            <div style={{
          fontWeight: 700,
          color: '#111'
        }} data-id="element-155">
              {review.name}
            </div>
            <div style={{
          color: '#22c55e',
          fontSize: '14px',
          margin: '4px 0'
        }} data-id="element-156">
              ★★★★★
            </div>
            <div style={{
          fontSize: '13px',
          color: '#4b5563',
          lineHeight: 1.5
        }} data-id="element-157">
              {review.text}
            </div>
          </div>)}
      </div>

      {/* Security Section */}
      <div style={{
      marginTop: '50px'
    }} data-id="element-158">
        <h3 style={{
        fontSize: '20px',
        fontWeight: 800,
        color: '#111'
      }} data-id="element-159">
          Tu compra es 100% segura
        </h3>

        <div style={{
        width: '60px',
        height: '3px',
        background: '#22c55e',
        margin: '12px auto 20px auto',
        borderRadius: '2px'
      }} data-id="element-160" />

        <p style={{
        fontSize: '14px',
        color: '#4b5563',
        lineHeight: 1.6,
        maxWidth: '500px',
        margin: '0 auto'
      }} data-id="element-161">
          Tenés 30 días de garantía. Si sentís que no es para vos o no estás
          conforme, nos mandás un email y te devolvemos el 100% de tu plata sin
          vueltas ni preguntas raras.
        </p>

        {/* Guarantee Card */}
        <div style={{
        margin: '25px auto 0 auto',
        background: '#ffffff',
        padding: '16px',
        borderRadius: '14px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
        maxWidth: '350px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'left'
      }} data-id="element-162">
          <div style={{
          fontSize: '22px'
        }} data-id="element-163">
            🛡️
          </div>
          <div data-id="element-164">
            <div style={{
            fontWeight: 700,
            color: '#16a34a',
            fontSize: '14px'
          }} data-id="element-165">
              Garantía de Satisfacción
            </div>
            <div style={{
            fontSize: '12px',
            color: '#4b5563'
          }} data-id="element-166">
              30 días para probar sin riesgo alguno
            </div>
          </div>
        </div>
      </div>
    </section>;
}